function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.902832 113.031C0.902832 135.411 12.2655 152.972 31.5495 163.992L76.3122 189.816C85.9548 195.325 89.0522 199.111 89.0522 204.277C89.0522 213.232 85.2642 217.708 68.7362 217.708C57.7188 217.708 28.7948 215.297 10.2015 212.885H8.82149C4.69216 212.885 2.28149 215.985 2.28149 219.429V247.319C2.28149 251.452 4.69216 254.205 8.82149 255.239C26.3842 260.06 52.5535 262.815 71.4908 262.815C121.766 262.815 145.177 237.333 145.177 204.965C145.177 186.372 138.981 168.468 110.401 151.939L67.7042 127.492C60.8175 123.361 57.0295 120.604 57.0295 115.442C57.0295 107.522 61.8508 105.453 75.2802 105.453C92.8415 105.453 122.452 108.555 132.439 109.929H133.472C136.916 109.929 139.324 107.521 139.324 103.388V75.4975C139.324 71.3669 136.916 68.6095 132.783 67.5761C115.222 63.1015 98.6935 59.6575 71.4908 59.6575C23.9748 59.6575 0.902832 78.2521 0.902832 113.031",
  fill: "url(#paint0_linear_720_5239)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1169.88 62.4121C1166.44 62.4121 1163.68 65.5135 1162.65 69.6442L1133.04 204.623C1132.01 209.788 1129.94 211.853 1127.53 211.853C1125.12 211.853 1123.4 209.788 1122.36 204.623L1092.75 69.6442C1091.72 65.5135 1088.96 62.4121 1085.52 62.4121H1040.07C1036.97 62.4121 1034.56 64.8227 1034.56 68.2667C1034.56 68.9561 1034.56 69.6442 1034.9 70.3322L1077.95 226.66C1086.56 257.307 1107.21 262.815 1127.53 262.815C1147.84 262.815 1168.85 257.307 1177.46 226.66L1220.84 70.3322C1221.19 69.6442 1221.19 68.9561 1221.19 68.2667C1221.19 64.8227 1218.43 62.4121 1215.34 62.4121H1169.88Z",
  fill: "url(#paint1_linear_720_5239)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1237.02 150.217V174.32C1237.02 240.777 1281.78 262.815 1323.45 262.815C1353.41 262.815 1372 260.06 1394.04 254.549C1399.89 253.173 1401.27 250.763 1401.27 245.253V219.084C1401.27 215.297 1398.51 213.575 1394.73 213.575H1393.69C1379.92 214.951 1349.27 216.673 1327.58 216.673C1300.38 216.673 1292.11 198.768 1292.11 179.141V178.453H1401.96C1406.43 178.453 1409.19 175.355 1409.19 170.189V150.217C1409.19 98.2241 1380.61 59.6575 1324.14 59.6575C1269.39 59.6575 1237.02 94.7801 1237.02 150.217M1292.11 142.641C1292.11 117.507 1304.86 104.422 1323.79 104.422C1343.08 104.422 1354.78 117.163 1354.78 142.641V144.019H1292.11V142.641Z",
  fill: "url(#paint2_linear_720_5239)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M1500.09 76.1867V69.2987C1500.09 65.5134 1496.99 62.412 1493.2 62.412H1452.22C1448.44 62.412 1445.34 65.5134 1445.34 69.2987V252.485C1445.34 256.271 1448.78 259.715 1452.57 259.715H1494.23C1498.02 259.715 1501.12 256.271 1501.12 252.485V117.849C1513.86 110.963 1528.67 105.8 1545.54 105.8H1548.29C1551.39 105.8 1553.46 102.356 1553.46 99.2561V66.5455C1553.46 62.7575 1550.36 59.6574 1546.57 59.6574C1530.04 59.6574 1512.83 65.5134 1500.09 76.1867",
  fill: "url(#paint3_linear_720_5239)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M1575.49 113.031C1575.49 135.411 1586.85 152.972 1606.13 163.992L1650.9 189.816C1660.54 195.325 1663.64 199.111 1663.64 204.277C1663.64 213.232 1659.85 217.708 1643.32 217.708C1632.3 217.708 1603.38 215.297 1584.79 212.885H1583.41C1579.28 212.885 1576.87 215.985 1576.87 219.429V247.319C1576.87 251.452 1579.28 254.205 1583.41 255.239C1600.97 260.06 1627.14 262.815 1646.08 262.815C1696.35 262.815 1719.76 237.333 1719.76 204.965C1719.76 186.372 1713.57 168.468 1684.99 151.939L1642.29 127.492C1635.4 123.361 1631.62 120.604 1631.62 115.442C1631.62 107.522 1636.44 105.453 1649.87 105.453C1667.43 105.453 1697.04 108.555 1707.03 109.929H1708.06C1711.5 109.929 1713.91 107.521 1713.91 103.388V75.4975C1713.91 71.3669 1711.5 68.6095 1707.37 67.5761C1689.81 63.1015 1673.28 59.6575 1646.08 59.6575C1598.56 59.6575 1575.49 78.2521 1575.49 113.031",
  fill: "url(#paint4_linear_720_5239)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M325.945 3.87731C322.156 3.87731 320.091 5.25464 318.369 8.00931L242.616 119.917V10.4187C242.616 6.63065 239.519 3.87731 235.729 3.87731H190.622C186.835 3.87731 183.735 6.63065 183.735 10.4187V252.828C183.735 256.617 186.835 259.715 190.622 259.715H235.729C239.519 259.715 242.616 256.617 242.616 252.828V141.265L312.515 254.896C314.236 257.649 315.959 259.715 320.091 259.715H379.316C382.416 259.715 384.138 258.339 384.138 256.271C384.138 255.239 383.792 253.863 382.76 252.485L300.465 128.869L382.416 12.4854C383.449 10.7641 384.138 9.0413 384.138 7.66263C384.138 5.5973 382.416 3.87731 378.627 3.87731H325.945Z",
  fill: "url(#paint5_linear_720_5239)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M393.085 111.308V152.283C393.085 232.17 438.193 262.815 495.005 262.815C551.823 262.815 596.931 232.17 596.931 152.283V111.308C596.931 31.4214 551.823 0.776179 495.005 0.776179C438.193 0.776179 393.085 31.4214 393.085 111.308M452.653 152.283V111.308C452.653 69.9894 466.084 52.4267 495.005 52.4267C523.931 52.4267 537.705 69.9894 537.705 111.308V152.283C537.705 193.603 523.931 211.164 495.005 211.164C466.084 211.164 452.653 193.603 452.653 152.283Z",
  fill: "url(#paint6_linear_720_5239)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M633.423 111.308V152.283C633.423 232.17 678.529 262.815 735.344 262.815C792.16 262.815 837.267 232.17 837.267 152.283V111.308C837.267 31.4214 792.16 0.776179 735.344 0.776179C678.529 0.776179 633.423 31.4214 633.423 111.308M692.991 152.283V111.308C692.991 69.9894 706.421 52.4267 735.344 52.4267C764.268 52.4267 778.043 69.9894 778.043 111.308V152.283C778.043 193.603 764.268 211.164 735.344 211.164C706.421 211.164 692.991 193.603 692.991 152.283Z",
  fill: "url(#paint7_linear_720_5239)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M886.5 3.87742C882.712 3.87742 879.613 6.97747 879.613 10.7641V188.784C879.613 251.452 919.212 262.815 963.631 262.815C981.879 262.815 1008.39 260.747 1019.76 258.339C1024.58 257.307 1026.64 255.584 1026.64 251.105V219.084C1026.64 215.297 1023.55 212.197 1019.76 212.197H960.531C944.348 212.197 938.495 206.688 938.495 188.784V10.7641C938.495 6.97747 935.396 3.87742 931.607 3.87742H886.5Z",
  fill: "url(#paint8_linear_720_5239)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M743.855 87.66C743.773 94.6254 738.108 100.248 731.124 100.248C730.3 100.248 729.497 100.163 728.717 100.013C728.099 101.853 727.748 103.817 727.748 105.865C727.748 116.003 735.967 124.22 746.104 124.22C756.243 124.22 764.46 116.003 764.46 105.865C764.46 95.7268 756.243 87.5093 746.104 87.5093C745.341 87.5093 744.593 87.5694 743.855 87.66",
  fill: "url(#paint9_linear_720_5239)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M505.94 87.66C505.859 94.6254 500.193 100.248 493.209 100.248C492.385 100.248 491.583 100.163 490.803 100.013C490.184 101.853 489.833 103.817 489.833 105.865C489.833 116.003 498.052 124.22 508.19 124.22C518.328 124.22 526.545 116.003 526.545 105.865C526.545 95.7268 518.328 87.5093 508.19 87.5093C507.427 87.5093 506.679 87.5694 505.94 87.66",
  fill: "url(#paint10_linear_720_5239)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M529.817 290.052C543.853 325.119 578.133 349.889 618.213 349.889C657.624 349.889 691.428 325.939 705.889 291.799C708.527 285.572 700.625 280.18 695.769 284.888C667.972 311.839 608.96 350.188 540.016 283.216C538.696 281.933 537.16 281.38 535.672 281.379C531.648 281.379 527.968 285.428 529.817 290.052",
  fill: "url(#paint11_linear_720_5239)"
});

var _ref14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_720_5239",
  x1: 73.0408,
  y1: 59.6578,
  x2: 73.0408,
  y2: 262.815,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#575756"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1.2e-7,
  stopColor: "#575756"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.473931,
  stopColor: "#1D1D1B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1D1D1B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_720_5239",
  x1: 1127.87,
  y1: 62.4121,
  x2: 1127.87,
  y2: 262.815,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#575756"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1.2e-7,
  stopColor: "#575756"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.473931,
  stopColor: "#1D1D1B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1D1D1B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_720_5239",
  x1: 1323.11,
  y1: 59.6578,
  x2: 1323.11,
  y2: 262.815,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#575756"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1.2e-7,
  stopColor: "#575756"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.473931,
  stopColor: "#1D1D1B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1D1D1B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_720_5239",
  x1: 1499.4,
  y1: 59.6577,
  x2: 1499.4,
  y2: 259.715,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#575756"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1.2e-7,
  stopColor: "#575756"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.473931,
  stopColor: "#1D1D1B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1D1D1B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_720_5239",
  x1: 1647.63,
  y1: 59.6578,
  x2: 1647.63,
  y2: 262.815,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#575756"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1.2e-7,
  stopColor: "#575756"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.473931,
  stopColor: "#1D1D1B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1D1D1B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_720_5239",
  x1: 605.189,
  y1: 0.776262,
  x2: 605.189,
  y2: 349.891,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8D71E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1.2e-7,
  stopColor: "#F8D71E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.862619,
  stopColor: "#F7A633"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7A633"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_720_5239",
  x1: 605.189,
  y1: 0.776455,
  x2: 605.189,
  y2: 349.891,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8D71E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1.2e-7,
  stopColor: "#F8D71E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.862619,
  stopColor: "#F7A633"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7A633"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_720_5239",
  x1: 605.189,
  y1: 0.776455,
  x2: 605.189,
  y2: 349.891,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8D71E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1.2e-7,
  stopColor: "#F8D71E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.862619,
  stopColor: "#F7A633"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7A633"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_720_5239",
  x1: 605.189,
  y1: 0.776354,
  x2: 605.189,
  y2: 349.891,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8D71E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1.2e-7,
  stopColor: "#F8D71E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.862619,
  stopColor: "#F7A633"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7A633"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_720_5239",
  x1: 605.189,
  y1: 0.775999,
  x2: 605.189,
  y2: 349.891,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8D71E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1.2e-7,
  stopColor: "#F8D71E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.862619,
  stopColor: "#F7A633"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7A633"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_720_5239",
  x1: 605.189,
  y1: 0.775999,
  x2: 605.189,
  y2: 349.891,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8D71E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1.2e-7,
  stopColor: "#F8D71E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.862619,
  stopColor: "#F7A633"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7A633"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_720_5239",
  x1: 605.189,
  y1: 0.776381,
  x2: 605.189,
  y2: 349.891,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8D71E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1.2e-7,
  stopColor: "#F8D71E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.862619,
  stopColor: "#F7A633"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7A633"
})));

function SvgLogoTinker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1720,
    viewBox: "0 0 1720 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTinker);
export default __webpack_public_path__ + "static/media/Logo-Tinker.98a9e2d8.svg";
export { ForwardRef as ReactComponent };